"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_navigation-footer.scss");

function NavigationFooter(_ref) {
  var children = _ref.children,
      onClickPrimary = _ref.onClickPrimary,
      primaryButtonText = _ref.primaryButtonText,
      primaryButtonBusy = _ref.primaryButtonBusy,
      primaryButtonDisabled = _ref.primaryButtonDisabled,
      onClickSecondary = _ref.onClickSecondary,
      secondaryButtonText = _ref.secondaryButtonText,
      secondaryButtonBusy = _ref.secondaryButtonBusy,
      secondaryButtonDisabled = _ref.secondaryButtonDisabled;
  return _react["default"].createElement("div", {
    className: "navigation-footer"
  }, _react["default"].createElement("div", {
    className: "navigation-footer__children"
  }, children), _react["default"].createElement("div", {
    className: "navigation-footer__controls"
  }, onClickSecondary ? _react["default"].createElement(_uiKit.Button, {
    onClick: onClickSecondary,
    small: !0,
    type: "SECONDARY",
    busy: secondaryButtonBusy,
    disabled: secondaryButtonDisabled
  }, secondaryButtonText) : null, onClickPrimary ? _react["default"].createElement(_uiKit.Button, {
    onClick: onClickPrimary,
    small: primaryButtonText,
    busy: primaryButtonBusy,
    disabled: primaryButtonDisabled
  }, primaryButtonText) : null));
}

NavigationFooter.defaultProps = {
  primaryButtonText: "Continue",
  secondaryButtonText: "Back"
};

var _default = (0, _react.memo)(NavigationFooter);

exports["default"] = _default;